import { useCheckoutSession } from "@circle-react/components/Paywalls/Checkout/contexts/CheckoutSessionContext";
import { usePaywallCheckoutContext } from "@circle-react/contexts/Paywalls/paywallCheckoutContext";

export const useHandleSuccessAuthentication = () => {
  const { refreshSession } = useCheckoutSession();
  const { refreshCheckoutPreview, handleError } = usePaywallCheckoutContext();

  const reloadPage = () => {
    void refreshSession()
      .catch(error =>
        handleError({
          message: error?.message,
          type: "danger",
          disablePayButton: false,
        }),
      )
      .finally(() => {
        void refreshCheckoutPreview();
      });
  };

  return {
    reloadPage,
  };
};
